<template>
  <path
    d="M8 27H22C23.1046 27 24 26.1046 24 25V8.82843C24 8.29799 23.7893 7.78929 23.4142 7.41421L19.5858 3.58579C19.2107 3.21071 18.702 3 18.1716 3H8C6.89543 3 6 3.89543 6 5V25C6 26.1046 6.89543 27 8 27Z"
    fill="#3769D6"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.04 17.0004H17.9594C18.3786 17.0004 18.6117 16.5154 18.3498 16.188L15.3901 12.4884C15.19 12.2382 14.8094 12.2382 14.6093 12.4884L11.6496 16.188C11.3877 16.5154 11.6207 17.0004 12.04 17.0004ZM17 17.0005H13V21.0005C13 21.5528 13.4477 22.0005 14 22.0005H16C16.5523 22.0005 17 21.5528 17 21.0005V17.0005Z"
    fill="white"
  />
  <path
    opacity="0.5"
    d="M17 9.5L17 6.20711C17 5.76165 17.5386 5.53857 17.8536 5.85355L21.1464 9.14645C21.4614 9.46143 21.2383 10 20.7929 10L17.5 10C17.2239 10 17 9.77614 17 9.5Z"
    fill="white"
  />
</template>
